import EventBus from '@/eventBus'

const MESSAGE_TYPES = {
  OPENTOK: 'opentok',
}

function handleOpenTok(doc, editor) {
  if (doc.action === 'stop-call') {
    if (editor.$store.state.voiceCall.audienceUnique === doc.data.audienceUnique) {
      EventBus.$emit('stop-video-call')
    }
  }
}

const OpentokWebsocketSubscriber = {
  [MESSAGE_TYPES.OPENTOK]: handleOpenTok,
}

export default OpentokWebsocketSubscriber
